import React from 'react';
import { useTranslation } from 'react-i18next';
import cls from 'clsx';
import { Collapse } from '@linktivity/link-ui';
import { ReactMarkdown } from '@link/share/components';
import { type FAQItemProps } from './FAQItem.types';
import styles from './faqItem.module.css';

const { Panel } = Collapse;

const FAQItem: React.FC<FAQItemProps> = ({
  items,
  sectionKey = '',
  className,
  panelClassName,
  answerClassName
}) => {
  const { t } = useTranslation();

  return (
    <Collapse accordion className={cls(styles.collapse, className)}>
      {items.map((item, index) => (
        <Panel
          className={cls(styles.panel, panelClassName)}
          key={`${sectionKey}-${index}`}
          header={t(item.question)}
        >
          <div className={cls(styles.answer, answerClassName)}>
            <ReactMarkdown source={t(item.answer)} />
          </div>
        </Panel>
      ))}
    </Collapse>
  );
};

export default FAQItem;
